import { isAxiosError } from "axios";
import { useCallback } from "react";

import { isPlatformRequestError } from ".";
import { useTT } from "../useTT";

export function useTranslateGenericError() {
  const { tt } = useTT();

  return useCallback(
    (err: Error) => {
      if (isPlatformRequestError(err, 500)) {
        return tt("genericErrors.error500");
      }

      if (isPlatformRequestError(err, 400, "EntitlementError")) {
        return tt("genericErrors.missingEntitlement");
      }

      if (
        isPlatformRequestError(
          err,
          401,
          "RequestAuthorizationRequired",
          "UserInteractionRequired",
        )
      ) {
        return tt("genericErrors.requestAuthorizationFailed");
      }

      if (isAxiosError(err) && !err.response) {
        return tt("genericErrors.serverUnreachable");
      }

      return tt("genericErrors.genericMessage");
    },
    [tt],
  );
}
